import { formatMoneyVN } from "@app/utils/util";
import UpgradeIcon from "@app/icons/upgrade";
import clsx from "clsx";
import { Upgrade } from "@app/types";
import CustomRadio from "../custom-radio";

interface UpgradeItemProps {
  upgrade: Upgrade;
  isChecked: boolean;
}

function UpgradeItem({ upgrade, isChecked }: UpgradeItemProps) {
  return (
    <div
      className={clsx(
        "w-[292px] h-[316px] bg-white rounded-2xl p-6 border-[2px] border-transparent cursor-pointer",
        {
          "border-[2px] border-solid !border-[#49C172]": isChecked,
        }
      )}
    >
      <div
        className={clsx(
          "w-9 h-9 rounded-lg bg-[#FFE9C7] flex items-center justify-center mx-auto",
          {
            "!bg-[#C2F4D3]": isChecked,
          }
        )}
      >
        {isChecked ? (
          <UpgradeIcon color="#49C172" />
        ) : (
          <UpgradeIcon color="#FC8B22" />
        )}
      </div>
      <div className="font-[SVN-Gilroy] text-lg font-semibold text-center">
        {upgrade.name}
      </div>
      <div className="mt-12 flex justify-center items-center font-[SVN-Gilroy]">
        <span className="text-[28px] font-semibold">
          {formatMoneyVN(upgrade.price)}đ
        </span>
        <div className="text-[#4E586C] lowercase">
          /
          {upgrade.time % 12 === 0
            ? `${upgrade.time / 12} Năm`
            : `${upgrade.time} Tháng`}
        </div>
      </div>
      <div className="text-[#4E586C] lowercase text-center">
        Thời hạn sử dụng:
        {upgrade.time % 12 === 0
          ? ` ${upgrade.time / 12} Năm`
          : ` ${upgrade.time} Tháng`}
      </div>
      <div className="mt-[76px] flex justify-center">
        <CustomRadio
          className="mb-4"
          checked={isChecked}
          outerClassName={clsx({ "!border-[#288564]": isChecked })}
          innerClassName={clsx({ "!bg-[#288564]": isChecked })}
        />
      </div>
    </div>
  );
}

export default UpgradeItem;
